import React from 'react';
import MaterialIcon from '@lib/components/MaterialIcon/MaterialIcon';
import { WidgetIconSource } from 'routes/Home/utils/getWidgetIconSource';

export interface WidgetIconRendererProps {
  /** Icon source data from getWidgetIconSource() */
  iconSource: WidgetIconSource;
  /** CSS class for attachment image */
  imageClassName?: string;
  /** CSS class for favicon image */
  faviconClassName?: string;
  /** Fallback icon name when no icon is available */
  fallbackIcon?: string;
  /** Whether to show fallback icon when iconSource.icon is undefined */
  showFallback?: boolean;
}

/**
 * Renders a widget icon based on the icon source type.
 * Handles three cases:
 * 1. Attachment - custom uploaded icon image
 * 2. Favicon - external link favicon
 * 3. Material - material design icon
 */
function WidgetIconRenderer({
  iconSource,
  imageClassName,
  faviconClassName,
  fallbackIcon = 'widgets',
  showFallback = true,
}: WidgetIconRendererProps) {
  if (iconSource.type === 'attachment' && iconSource.url) {
    return <img src={iconSource.url} alt="" className={imageClassName} />;
  }

  if (iconSource.type === 'favicon' && iconSource.url) {
    return <img src={iconSource.url} alt="" className={faviconClassName} />;
  }

  const iconName = iconSource.icon || (showFallback ? fallbackIcon : null);

  if (iconName) {
    return <MaterialIcon icon={iconName} size="md-24" symbolsOutlined />;
  }

  return null;
}

export default WidgetIconRenderer;
